import React from "react";
import { ErrorPanelComponent } from "./error_panel.component";
import { useTranslation } from "react-i18next";

export const NotFoundComponent = () => {
  const { t } = useTranslation();

  return (
    <ErrorPanelComponent title={t("NotFound_Title")}>
      {t("NotFound_Message")}
    </ErrorPanelComponent>
  );
};
